import { render, staticRenderFns } from "./ActivationCodeIcon.vue?vue&type=template&id=0572a4fc"
import script from "./ActivationCodeIcon.vue?vue&type=script&lang=js"
export * from "./ActivationCodeIcon.vue?vue&type=script&lang=js"
import style0 from "./ActivationCodeIcon.vue?vue&type=style&index=0&id=0572a4fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports